import React from "react";

/**
 * Muestra una imagen de documento legacy (INE, CURP, etc.) cargándola por fetch+blob
 * para evitar que el navegador descargue automáticamente al abrir el modal
 * (las URLs firmadas de S3 pueden devolver Content-Disposition: attachment).
 */
const SafeLegacyImage = ({
  url,
  alt = "",
  className,
  style,
}: {
  url: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
}) => {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    if (!url) {
      setLoading(false);
      setError(true);
      return;
    }
    setLoading(true);
    setError(false);
  }, [url]);

  if (!url) {
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
          minHeight: "150px",
        }}
      >
        <span className="text-muted">No se pudo cargar la imagen</span>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
          minHeight: "150px",
        }}
      >
        <span className="text-muted">No se pudo cargar la imagen</span>
      </div>
    );
  }

  return (
    <>
      {loading && (
        <div
          className={className}
          style={{
            ...style,
            display: loading ? "flex" : "none",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
            minHeight: "150px",
          }}
        >
          <span className="text-muted">Cargando...</span>
        </div>
      )}
      <img
        src={url}
        alt={alt}
        className={className}
        style={{
          ...style,
          display: loading ? "none" : undefined,
        }}
        onLoad={() => setLoading(false)}
        onError={() => {
          setLoading(false);
          setError(true);
        }}
      />
    </>
  );
};

export default SafeLegacyImage;
